<template>
  <div class="footer-container">
    <div class="footer">
      <img class="logo" src="@/assets/logo.png" alt="">
      <div class="detail-info">
        <div class="info info-1">
          <div>版权所有©嘉兴职业技术学院</div>
          <div>地址:浙江省嘉兴市桐乡大道547号</div>
          <div class="mar-top-15"><a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备16001554号-1</a></div>
          <div><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33049802000256" target="_blank">浙公网安备 33049802000256号</a></div>
        </div>
        <div class="info info-2">
          <a class="group-link" href="http://bszs.conac.cn/sitename?method=show&id=274AFC546A7B119EE053012819AC3C95"><img class="group" src="@/assets/group.png" alt=""></a>
          <div>友情链接：</div>
          <div class="link-list">
            <a class="link" href="http://www.moe.gov.cn/" target="_blank">中华人民共和国教育部</a>
            <a class="link" href="https://www.tech.net.cn/" target="_blank">中国高职高专教育网</a>
            <a class="link" href="http://jyt.zj.gov.cn/" target="_blank">浙江省教育厅</a>
          </div>
        </div>
        <div class="info info-3">
          <div>邮编：314036</div>
          <div class="phone-box">
            <div>电话：</div>
            <div>
              <div>0573-89978066</div>
              <div>82751212</div>
              <div>89978111</div>
              <div>89978123</div>
              <!-- <div>89978123、82751117</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.footer-container {
  height: 245px;
  background: linear-gradient(180deg, #9bb3e3, #4370ca);
  .footer {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    padding-top: 110px;
    .logo {
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
    }
    .detail-info {
      height: 103px;
      display: flex;
      .info {
        flex: 1;
        font-size: 14px;
        color: #D0E0FF;
        a {
          color: #D0E0FF;
          text-decoration: none;
        }
      }
      .info-1 {
        //width: 350px;
        padding-left: 50px;
        line-height: 22px;
      }
      .info-2 {
        position: relative;
        display: flex;
        //width: 410px;
        padding-left: 90px;
        border: 1px solid rgba(255,255,255,0.3);
        border-top-color: transparent;
        border-bottom-color: transparent;
        .link-list {
          flex: 1;
          padding-left: 36px;
          .link {
            display: table;
            margin-bottom: 21px;
          }
        }
        .group-link {
          position: absolute;
          top: 34px;
          left: 95px;
        }
      }
      .info-3 {
        //flex: 1;
        padding-left: 85px;
        line-height: 24px;
        .phone-box {
          display: flex;
        }
      }
      .mar-top-15 {
        margin-top: 15px;
      }
    }
  }
}
</style>
